import { CreatedIcon, TagsIcon } from '@blocksuite/icons/rc';
import type {
  Literal,
  LiteralValue,
  PropertiesMeta,
  VariableMap,
} from '@pique/env/filter';
import { Users, Video } from 'lucide-react';
import type { ReactElement } from 'react';

import { tAttendee, tDate, tTag, tTitle } from './logical/custom-type';
import type { TType } from './logical/typesystem';
import { tArray } from './logical/typesystem';

export const toLiteral = (value: LiteralValue): Literal => ({
  type: 'literal',
  value,
});

export type FilterVariable = {
  name: keyof VariableMap;
  type: (propertiesMeta: PropertiesMeta) => TType;
  icon: ReactElement;
};

export const variableDefineMap = {
  Title: {
    type: () => tArray(tTitle.create({ titles: [] })),
    icon: <Video size={16} />,
  },
  Created: {
    type: () => tDate.create(),
    icon: <CreatedIcon />,
  },
  Tags: {
    type: (meta: PropertiesMeta) => tArray(tTag.create({ tags: meta.tags?.options ?? [] })),
    icon: <TagsIcon />,
  },
  Attendees: {
    type: () => tArray(tAttendee.create({ attendees: [] })),
    icon: <Users size={16} />,
  },
} satisfies Record<string, Omit<FilterVariable, 'name'>>;

export type InternalVariableMap = {
  [K in keyof typeof variableDefineMap]: LiteralValue;
};

declare module '@pique/env/filter' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface VariableMap extends InternalVariableMap {}
}
